import {SAVED_PLACE_HOME_TYPE, SAVED_PLACE_WORK_TYPE} from '../redux/actions/savedPlacesActions';

export function savedPlacesHomeWork(specific) {
    return {
        home: specific.find((place) => place.type === SAVED_PLACE_HOME_TYPE) || null,
        work: specific.find((place) => place.type === SAVED_PLACE_WORK_TYPE) || null,
    }
}